import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rt-sidebar-label',
  templateUrl: './sidebar-label.component.html',
  styleUrls: ['./sidebar-label.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class SidebarLabelComponent {
  public readonly label = input<string>(undefined!);
}
